// extracted by mini-css-extract-plugin
module.exports = {"identifier":"style_identifier__3vwzh","avatar":"style_avatar__1CVEO"};